// File types and interfaces

export type SupportedFileFormat = 'shp' | 'zip' | 'gpkg';

export type FileStatus = 'pending' | 'uploading' | 'uploaded' | 'processing' | 'complete' | 'error';

export interface FileInfo {
    id: string;
    name: string;
    size: number; // bytes
    type: SupportedFileFormat;
    uploadedAt: Date;
    status: FileStatus;
}

export interface UploadProgress {
    fileId: string;
    bytesUploaded: number;
    totalBytes: number;
    percentage: number;
}

export interface ValidationResult {
    valid: boolean;
    errors: ValidationError[];
}

export interface ValidationError {
    code: string;
    message: string;
    field?: string;
}

// File validation constants
export const FILE_VALIDATION = {
    maxFileSize: 50 * 1024 * 1024, // 50MB
    acceptedExtensions: ['.shp', '.zip', '.gpkg'],
    acceptedMimeTypes: [
        'application/zip',
        'application/x-zip-compressed',
        'application/octet-stream',
        'application/geopackage+sqlite3',
    ],
} as const;
